import React from "react";
import { Sidebar } from "./Sidebar";
import { LayoutContent } from "./LayoutContent";
import { useElementSize } from "usehooks-ts";
import { useSidebar } from "../hooks/use-sidebar";

export const Layout: React.FC = () => {
  const [squareRef, { width }] = useElementSize();
  const { isSidebarExpanded, setIsExpanded } = useSidebar(width as any);

  return (
    <div className={"flex flex-row"} ref={squareRef}>
      <Sidebar isExpanded={isSidebarExpanded} setIsExpanded={setIsExpanded} />
      <LayoutContent isSidebarExpanded={isSidebarExpanded} />
    </div>
  );
};
